import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { Typography, Card } from '@app-velocity/ui';

import { I18nResources, useI18n } from '@app-velocity/i18n';

const StyledCard = styled(Card)<{ variant: 'default' | 'primary' }>(
  ({ theme, variant }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px solid ${
      variant === 'primary'
        ? 'var(--button-button-primary-color)'
        : 'var(--stroke-stroke-primary-color)'
    }`,
  })
);

const StyledText = styled(Typography)({
  lineHeight: 1.5,
  fontSize: 13,
  color: 'var(--text-text-secondary-color)',
  maxWidth: '75%',
});

export type CardProps = {
  icon: ReactNode;
  action: ReactNode;
  text: I18nResources;
  variant?: 'default' | 'primary';
  additionalAction?: ReactNode;
};

export const HomeCard = ({
  icon,
  action,
  text,
  variant = 'default',
  additionalAction,
}: CardProps) => {
  const { t } = useI18n();

  return (
    <StyledCard variant={variant}>
      {icon}
      <StyledText>{t(text)}</StyledText>
      {action}
      {additionalAction}
    </StyledCard>
  );
};
